// Ported from relay-protocol packages/relay-widget (v0.1.0).
// Ported verbatim from frontend/src/hooks/useDebouncedValue.ts -- no
// behavior changes, just relocated into the framework-agnostic-consumer
// package so useDepositAddress can debounce the live-quote inputs.
import { useEffect, useState } from 'react'

/** Returns `value`, delayed by `delayMs` after it last changed. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
